var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", { staticClass: "emd-text eu-mt_1" }, [
    _vm._v(" " + _vm._s(_vm.$t("keys.description")) + " "),
    _c(
      "a",
      {
        staticClass: "emd-text _color_primary _type_caption",
        attrs: {
          target: "_blank",
          rel: "noopener",
          href: "https://docs.pagar.me/docs/chaves-de-acesso",
        },
      },
      [_vm._v(" " + _vm._s(_vm.$t("keys.description-anchor")) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }